import React, { useEffect, useState } from "react";
import "./Footer.css";
import { withRouter } from "react-router-dom";
import { RoutePaths } from "../../Constants";
import { PROCURE_URLS } from '../../Urls';
import classes from "./Footer.module.css";
import { Activity, currentRequestTimeStamp } from "../../Constants";

let isMobile = window.innerWidth < 600;

const Footer = ({ history }) => {
  useEffect(() => {
    history.location.pathname.toLowerCase() ===
    RoutePaths.MyAccount.toLowerCase()
      ? setShowTermsOfUse(true)
      : setShowTermsOfUse(false);
  }, [history.location.pathname]);

  const [showTermsOfUse, setShowTermsOfUse] = useState(false);
  const [ProcureNow, setProcureNow] = useState("yes");

  const sitemapContent = [
    {
      label: "LoRRI Spot",
      value: "Find and book transporters for on-demand, short-term placements",
      type: "link",
      link: "/trucks/enquiries",
      desc: "If you’re a business in need of immediate transportation solutions or a transporter looking to expand your reach, LoRRI Spot simplifies the process, offering flexibility, efficiency, and reliability in securing transport services.",
    },
    {
      label: "LoRRI Indent",
      value: "Explore your Indents",
      type: "link",
      link: "/indents",
      desc: "",
    },
    {
      label: "LoRRI Invoice",
      type: "link",
      link: "/invoice",
      value:
        "Streamlines invoice management by viewing, accepting, rejecting, invoices.",
      desc: "Helps to manage the invoice process by allowing the transporter to generate the receipt, followed by the creation of the Proof of Delivery (POD). Based on this, the invoice for the entire shipment is generated and sent to the Supply Chain Manager (SCM). The SCM can then view the receipt and POD, with the option to approve or reject the invoice",
    },
    {
      label: "My Account",
      value: "View industry rating for your rated transporters",
      type: "link",
      link: "/myAccount",
      desc: "View industry rating for your rated transporters, upload your contracts, view shortlisted and viewed transporters. Refer LoRRI to your peers across the industry.",
    },
  ];
  const siteMapSecondRow = [
    ProcureNow === "yes"
      ? {
          label: "LoRRI Procure",
          value:
            "Manage and run an end-to-end procurement for all your transportation needs",
          type: "link",
          link: PROCURE_URLS.LOGIN(sessionStorage.getItem("uid")),
          desc: "Create, run, and manage end-to-end transportation procurement in LoRRI-Procure. Float notifications, schedules, and documents directly to shortlisted transporters. Analyze 100+ RFQ responses in minutes with intelligent insights, and request contract closure docs with a click. Utilize lotting features, group lanes with nodal child relationships, and automate RFQ round start/close for seamless efficiency.",
        }
      : {
          label: "LoRRI-Procure",
          value:
            "Manage and run an end-to-end procurement for all your transportation needs",
          type: "link",
          desc: "Create, run, and manage end-to-end transportation procurement in LoRRI-Procure. Float notifications, schedules, and documents directly to shortlisted transporters. Analyze 100+ RFQ responses in minutes with intelligent insights, and request contract closure docs with a click. Utilize lotting features, group lanes with nodal child relationships, and automate RFQ round start/close for seamless efficiency.",
        },
    {
      label: "LoRRI Auctions",
      value: "Host reverse auctions on lanes to achieve maximum savings.",
      type: "link",
      link: PROCURE_URLS.LOGIN(sessionStorage.getItem("uid")),
    },
    {
      label: "LoRRI Planning",
      value:
        "Plan routes, assign trucks, and manage dispatch schedules for smooth operations.",
      type: "link",
      link: "/planning/dashboard",
    },
    {
      label: "LoRRI Auto Scheduling",
      value:
        "Optimize truck dispatch using GPS coordinates for efficient route scheduling",
      type: "link",
      link: "/capacityplanning/fileupload",
      desc: "Leverage GPS coordinates to determine the most efficient delivery routes, minimizing distance and optimizing truck dispatch schedules. Optimizes the weights and volumes of goods in the truck, ensuring better load distribution and increased efficiency in deliveries.",
    },
  ];
  const siteMapFirstRow = [
    {
      label: "Company Profile",
      value:
        "Manage and update your company details, team, terms & conditions and masters",
      desc: "Edit company profile, manage team and organization, update terms and conditions, and configure different masters for efficient route management",
      type: "link",
      link: "/companyprofilenew/generalinfo",
    },
    {
      label: "LoRRI Location Dashboard",
      value:
        "Explore transporters and available truck types for your plant locations",
      type: "link",
      link: "/locationdashboard",
      desc: "Search across 600+ districts of India and get a glimpse at number of transporters and truck types plying their trade in that location. View detailed transporter profiles as submitted by the transporters themselves.",
    },
    {
      label: "LoRRI Benchmark",
      value: "Find “Freight Rate Range” for lane(s) of your choice.",
      type: "link",
      link: "/benchmarknow",
      desc: "Understand your standing in terms of freight rate in the market and find lanes where you can save more!",
    },
    {
      label: "LoRRI DiscoverNow",
      value: "Search for optimum transporters for your lane",
      type: "link",
      link: "/DiscoverNow",
      desc: "Discover the best transporters available in a particular lane, view their detailed profiles, shortlist and compare transporters.",
    },
  ];
  const CardContainer = () => {
    return (
      <div className={classes["card-main-container"]}>
        {siteMapFirstRow?.map((item, index) => {
          return item.type === "link" ? (
            <a className={classes.siteMapBoxfirst} key={index} href={item.link}>
              <div
                // style={{ minWidth: "250px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </a>
          ) : (
            <div
              className={classes.siteMapBoxfirst}
              key={index}
              onClick={(e) => document.getElementById(item.link).click()}
            >
              <div
                // style={{ minWidth: "250px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </div>
          );
        })}

        {siteMapSecondRow?.map((item, index) => {
          return item.type === "link" ? (
            <a
              className={classes.siteMapBoxSecond}
              key={index}
              href={item.link}
            >
              <div
                // style={{ minWidth: "250px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </a>
          ) : (
            <div
              className={classes.siteMapBoxSecond}
              key={index}
              onClick={(e) => document.getElementById(item.link).click()}
            >
              <div
                // style={{ minWidth: "250px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </div>
          );
        })}

        {sitemapContent?.map((item, index) => {
          return item.type === "link" ? (
            <a className={classes.siteMapBox} key={index} href={item.link}>
              <div
                // style={{ minWidth: "150px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </a>
          ) : (
            <div
              className={classes.siteMapBox}
              key={index}
              onClick={(e) => document.getElementById(item.link).click()}
            >
              <div
                // style={{ minWidth: "150px" }}
                // data-toggle="tooltip"
                // data-placement="bottom"
                title={item.desc}
              >
                <h2
                  className={classes.siteMaph2}
                  // style={h2Styles}
                >
                  {item.label}
                </h2>
                <p className={classes.boxPara}>{item.value}</p>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const SiteMap = () => {
    return (
      <div id="SiteMapContainer" className={`${classes["SiteMapContainer"]}`}>
        <a
          style={{ marginTop: "-2%" }}
          className={`${classes["closePopUp"]} ${classes["s-closepopup"]}`}
          onClick={closeSiteMap}
        >
          <i className="fa fa-times"></i>
        </a>

        <div>
          <h4 style={{ color: "black", fontSize: "22px" }}>
            <b>LoRRI Site Map</b>
          </h4>
          <hr
            style={{
              height: "1px",
              margin: "10px 0px",
              border: "none",
              color: "gray",
              backgroundColor: "gray",
            }}
          />
          <CardContainer />
        </div>
      </div>
    );
  };

  // const showSiteMap = () => {
  //   Activity([
  //     {
  //       screen: "Site Map",
  //       module: "Site Map",
  //       user_activity: `Site Map link clicked on footer`,
  //       timestamp: currentRequestTimeStamp(),
  //     },
  //   ]);
  //   document.getElementById("SiteMapContainer").style.left = "7%";
  //   // document..style.overflow='hidden'
  //   // document.getElementById('app-body').style.overflow = "hidden"
  // };

  const closeSiteMap = () => {
    document.getElementById("SiteMapContainer").style.left = "-200%";
    // document.getElementById('app-body').style.overflowY='auto'
    // document.getElementById('app-body').style.overflowX='hidden'
  };

  const FooterLinks = () => (
    <>
      {isMobile ? (
        <span
          className={`${classes["s-foot"]} ${classes["footer-link-container"]}`}
        >
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/faq.html"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes["s-small"]} ${classes["link"]}`}
          >
            FAQs
          </a>
          <a
            className={`${classes["s-site"]} ${classes["link"]}`}
            href="/sitemap"
            target="_blank"
            rel="noopener noreferrer"
          >
            | SiteMap
          </a>
        </span>
      ) : (
        <span
          className={`${classes["s-foot"]} ${classes["footer-link-container"]}`}
        >
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/faq.html"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes["s-small"]} ${classes["link"]} link`}
          >
            FAQs
          </a>
          <a
            href="/sitemap"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes["s-site"]} ${classes["link"]}`}
          >
            | SiteMap
          </a>

          {showTermsOfUse ? (
            <>
              <span>|</span>
              <a
                href="https://lntermsandconditions.blob.core.windows.net/tnc/tnc.html"
                target="_blank"
                rel="noopener noreferrer"
                className={`${classes["s-small"]} ${classes["link"]}`}
              >
                Terms of Use
              </a>
              |
              <a
                href="https://lntermsandconditions.blob.core.windows.net/tnc/privacypolicy.html"
                target="_blank"
                rel="noopener noreferrer"
                className={`${classes["s-small"]} ${classes["link"]}`}
              >
                Privacy Policy
              </a>
            </>
          ) : null}
        </span>
      )}
    </>
  );

  return (
    <div id="footer" className="app-footer">
      <SiteMap />
      {/* <div className="row"> */}
      <div className="col-md-12">
        <div className="copyrights">
          <span>© 2026 LogisticsNow. All Rights Reserved.</span>
          <FooterLinks />
        </div>
      </div>
    </div>
    // </div>
  );
};

export default withRouter(Footer);
